export const credentialsKey = 'intello_credentials_u8fzeshfiu4832i9fj';
